/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FieldValueType = {
    Text: 'Text',
    Money: 'Money',
    Date: 'Date',
    Time: 'Time',
    DateTime: 'DateTime',
    Boolean: 'Boolean',
    FixedSet: 'FixedSet',
    Reference: 'Reference',
    Percent: 'Percent'
} as const;
export type FieldValueType = typeof FieldValueType[keyof typeof FieldValueType];


export function instanceOfFieldValueType(value: any): boolean {
    for (const key in FieldValueType) {
        if (Object.prototype.hasOwnProperty.call(FieldValueType, key)) {
            if (FieldValueType[key as keyof typeof FieldValueType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FieldValueTypeFromJSON(json: any): FieldValueType {
    return FieldValueTypeFromJSONTyped(json, false);
}

export function FieldValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldValueType {
    return json as FieldValueType;
}

export function FieldValueTypeToJSON(value?: FieldValueType | null): any {
    return value as any;
}

export function FieldValueTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FieldValueType {
    return value as FieldValueType;
}

